import { useEffect, useRef, useState } from 'react';

function useDrop(ref, onLoad = () => {}) {
  const [uploading, setUploading] = useState(false);
  const [isOver, setOver] = useState(false);
  const uploadingRef = useRef(false);
  const stopDefault = e => {
    e.preventDefault();
    e.stopPropagation();
  };
  useEffect(() => {
    const dragLeaveHandler = e => {
      setOver(false);
      stopDefault(e);
    };
    const dragOverHandler = e => {
      setOver(true);
      stopDefault(e);
    };
    const dropHandler = e => {
      setOver(false);
      stopDefault(e);
      uploadHandler(e.dataTransfer.files);
    };

    const uploadHandler = files => {
      if (
        files &&
        Array.from(files).some(
          file =>
            file &&
            (/\.md$/i.test(file.name) ||
              (file.type && file.type.startsWith('image/')) ||
              /\.(avif|bmp|gif|jpe?g|png|svg|webp)$/i.test(file.name))
        ) &&
        !uploadingRef.current
      ) {
        uploadingRef.current = true;
        setUploading(true);
        onLoad(files, () => {
          uploadingRef.current = false;
          setUploading(false);
        });
      }
    };
    const target = ref.current;
    if (!target) return;
    target.addEventListener('dragenter', stopDefault, true);
    target.addEventListener('dragover', dragOverHandler, true);
    target.addEventListener('dragleave', dragLeaveHandler, true);
    target.addEventListener('drop', dropHandler, true);
    return () => {
      target.removeEventListener('dragenter', stopDefault, true);
      target.removeEventListener('dragover', dragOverHandler, true);
      target.removeEventListener('dragleave', dragLeaveHandler, true);
      target.removeEventListener('drop', dropHandler, true);
    };
  }, [ref, onLoad]);
  return [uploading, isOver];
}

export default useDrop;
